export default function convertFileSize (size: number) {
    if (size >= 1024) {
        const res = Math.round(Math.round((size / 1024 + Number.EPSILON) * 100) / 100);
        if (res >= 1024) {
            return Math.round(res / 1024);
        }
        return res;
    }

    return size;
}